import {Routes} from '@angular/router';
import {AuthGuard} from '@core/services/auth-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import {
  ViewAnalyticsEatWorkflowComponent
} from "@features/oic/components/view-analytics-eat-workflow/view-analytics-eat-workflow.component";

export const oicRoutes: Routes = [
  {
    path: 'oic/return',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'oic/return/link/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'oic/return/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path      : 'oic/return/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'oic/dashboard',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'oic/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'oic/analytics',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'oic/return/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'analytics/eat/active/:flowId',
    component: ViewAnalyticsEatWorkflowComponent
  },
  {
    path      : 'oic/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
];
